import { LeadsRegistryHeader } from '@app/pages/Leads/LeadsRegistryPage/ui/LeadsRegistryHeader';

import type { FC } from 'react';

import './LeadsFunnelsHeader.scss';

export const LeadsFunnelsHeader: FC = () => {
  return <LeadsRegistryHeader viewMode="funnels" />;
};
